import React, { useState } from 'react';
import { Oval } from 'react-loader-spinner';

const Confirm = ({ open, onClose, onAccept, onDecline, message }) => {

  const [loading, setLoading] = useState(false)
  
  return (
    <>
      {open && (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black bg-opacity-50">
          <div className="w-full max-w-md p-6 bg-white rounded-lg shadow-lg dark:bg-gray-800">
            <h3 className="mb-4 text-xl font-bold text-gray-800 dark:text-gray-200">Confirmez votre choix</h3>
            <p className="mb-6 text-gray-600 dark:text-gray-200">{message}</p>
            <div className="flex justify-end gap-4">
              {!loading && <div
                className="px-4 py-2 font-bold text-red-700 transition-all duration-500 rounded-full cursor-pointer animate-fade hover:bg-red-600 hover:bg-opacity-10"
                onClick={onDecline}
              >
                Annuler
              </div>}
              
              {!loading ? <button
                className="px-4 py-2 font-bold text-indigo-700 transition-all duration-500 rounded-full cursor-pointer animate-fade hover:bg-blue-600 hover:bg-opacity-10"
                onClick={async ()=>{ 
                  setLoading(true) 
                  setLoading(false)
                  onClose()
                  await onAccept()
                }}
              >
                Confirmer
              </button> : 
                
                <Oval
                  height={20}
                  width={20}
                  color="#ffffff"
                  visible={true}
                  ariaLabel="oval-loading"
                  secondaryColor="#cccccc"
                  strokeWidth={2}
                  strokeWidthSecondary={2}
                />
              }
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Confirm;
